export default __webpack_public_path__ + "static/media/beta_alternate.fa929d5d.svg";